module.exports = __webpack_public_path__ + "static/media/vox-music.2822f9c9.png";